export default __webpack_public_path__ + "static/media/8_Intro.4c5ef262.mp4";